import useSettingsService from 'components/hooks/useSettingsService';
import { SETTING_NAMES } from 'common/constants/constants';
import map from 'lodash/map';

const useReleaseStages = () => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const settingValue = getSettingOrDefinitionValue({
    name: SETTING_NAMES.RELEASE_STAGES
  });
  const stageKeys = [...map(settingValue, stage => stage.key), 'release'];

  return {
    settingValue,
    stageKeys
  };
};

export default useReleaseStages;
